import cx from 'classnames';
import React from 'react';
import { withRouter } from 'react-router';
import { Container } from 'reactstrap';
import auth from './../AuthService';
import AsClient from './AsClient';
import { NavMenu } from './NavMenu';

const L = props => {
    const hide = hideHeader();
    return (
        <div>
            {!hide && <NavMenu />}
            <Container className={cx('body-container', {
                iniframe: hide
                })}>
                {props.children}
                <AsClient />
            </Container>
        </div>
    );
};

export const inIframe = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};

export const hideHeader = () => {
    if (inIframe()) {
        return true;
    }
    if (auth.getInstance().isAdmin()) {
        return false;
    }

    return true;
};

export const Layout = withRouter(L);


// WEBPACK FOOTER //
// ./src/components/Layout.js